import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

export default function VideoPlayer ({ title, url, closeVideo, isVisible }) {
  return (
    isVisible && (
      <div
        className='video-container'
        onClick={event => (event.target === event.currentTarget ? closeVideo(false) : null)}
      >
        <div className='teacher-video'>
          <iframe src={url} title={title} allowFullScreen />
        </div>
      </div>
    )
  )
}

VideoPlayer.propTypes = {
  isVisible: PropTypes.bool,
  closeVideo: PropTypes.func,
  url: PropTypes.string,
  title: PropTypes.string
}
